import React from 'react';
import { Box, Text, Image, VStack } from '@chakra-ui/react';
import NoData from "assets/img/empty.png";

const NoDataFound = ({
  message,
  width = "150px",
  height = "150px",
  fontSize = "lg",
  fontWeight = "normal",
  textColor = "gray.500"
}) => {
  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      height="100%"
      p={4}
    >
      <VStack spacing={4}>
        <Image
          src={NoData}
          alt="No Data Found"
          boxSize={width}
          height={height}
          objectFit="cover"
        />
        <Text fontSize={fontSize} fontWeight={fontWeight} color={textColor}>
          {message || 'No data available'}
        </Text>
      </VStack>
    </Box>
  );
};

export default NoDataFound;
